import { create } from "zustand";

import { type MetadataOption, type MetricWSnap } from "../../../../../types";
import { DRAWER_TYPES } from "../constants";

type DrawerType = (typeof DRAWER_TYPES)[keyof typeof DRAWER_TYPES];

type DrawerDataMap = {
  [DRAWER_TYPES.ALLOCATION]: MetadataOption;
  [DRAWER_TYPES.METRIC]: MetricWSnap;
};

type DrawerData<T extends DrawerType = DrawerType> = T extends keyof DrawerDataMap
  ? DrawerDataMap[T]
  : MetadataOption | MetricWSnap;

type DrawerState = {
  isOpen: boolean;
  type: DrawerType | null;
  data: DrawerData | null;
};

interface DrawerActions {
  openDrawer: <T extends DrawerType>(type: T, data?: DrawerData<T>) => void;
  closeDrawer: () => void;
  openAllocation: (allocationData: MetadataOption) => void;
  openMetric: (metricData: MetricWSnap) => void;
}

type DrawerStore = DrawerState & DrawerActions;

export const useDrawerStore = create<DrawerStore>((set, get) => ({
  // State
  isOpen: false,
  type: null,
  data: null,

  // Actions
  openDrawer: <T extends DrawerType>(type: T, data?: DrawerData<T>) => {
    set({
      isOpen: true,
      type,
      data: data || null,
    });
  },

  closeDrawer: () => {
    set({
      isOpen: false,
      type: null,
      data: null,
    });
  },

  openAllocation: (allocationData) => {
    get().openDrawer(DRAWER_TYPES.ALLOCATION, allocationData);
  },

  openMetric: (metricData) => {
    get().openDrawer(DRAWER_TYPES.METRIC, metricData);
  },
}));
